<template>
  <div class="error-page">
    <h1>404 - 页面不存在</h1>
    <el-button @click="$router.push('/')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound'  // 原为 name: '404'
}
</script>